export const ROUTES = {
  VAULTS: 'vaults',
  LP_VAULTS: 'lp-vaults',
  DASHBOARD: 'dashboard',
  LEADERBOARD: 'leaderboard',
  TERMS: 'terms',
  PRIVACY_POLICY: 'privacy-policy',
}
